import React from "react";
import { Text } from "@chakra-ui/react";
import { Modal } from "newui/components/ui/Modal";
import { RfxDocumentRow } from "../types/rfx-document.types";

interface DocumentDeleteModalProps {
  isOpen: boolean;
  documents: RfxDocumentRow[];
  isDeleting?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const DocumentDeleteModal = ({
  isOpen,
  documents,
  isDeleting,
  onConfirm,
  onClose,
}: DocumentDeleteModalProps) => {
  const count = documents.length;
  const title =
    count === 1
      ? `Delete "${documents[0]?.fileName}"`
      : `Delete ${count} Documents`;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      modalType="alert"
      iconType="warning"
      description={
        count === 1 ? (
          <Text>
            Are you sure you want to permanently delete{" "}
            <strong>{documents[0]?.fileName}</strong>? This action cannot be
            undone.
          </Text>
        ) : (
          <Text>
            Are you sure you want to permanently delete{" "}
            <strong>{count} documents</strong>? This action cannot be undone.
          </Text>
        )
      }
      primaryButton={{
        text: isDeleting ? "Deleting..." : "Delete",
        btntype: "primary",
        isLoading: isDeleting,
        onClick: onConfirm,
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
      }}
    >
      <></>
    </Modal>
  );
};
